import { createTheme } from '@mui/material/styles';

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: mode === 'dark' ? '#F2732A' : '#E85D04',
      light: mode === 'dark' ? '#F98A48' : '#F2853A',
      dark: mode === 'dark' ? '#E0651E' : '#CF5203',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: mode === 'dark' ? '#D4A64A' : '#5B1A1E',
      light: mode === 'dark' ? '#E3BF74' : '#7A2A2F',
      dark: mode === 'dark' ? '#B98A2E' : '#4A1418',
      contrastText: '#FFFFFF',
    },
    background: {
      default: mode === 'dark' ? '#14100D' : '#FCF7F1',
      paper: mode === 'dark' ? '#1D1713' : '#FFFFFF',
      gradient: mode === 'dark'
        ? 'linear-gradient(135deg, #F2732A, #D4A64A)'
        : 'linear-gradient(135deg, #E85D04, #F2853A)',
    },
    text: {
      primary: mode === 'dark' ? '#F3EAE0' : '#2A1B12',
      secondary: mode === 'dark' ? '#CDBBAA' : '#5A4636',
    },
    divider: mode === 'dark' ? '#35291F' : '#EFE3D6',
    action: {
      hover: mode === 'dark' ? 'rgba(242, 115, 42, 0.10)' : 'rgba(232, 93, 4, 0.08)',
      selected: mode === 'dark' ? 'rgba(242, 115, 42, 0.18)' : 'rgba(232, 93, 4, 0.14)',
    },
    temple: {
      saffron: '#E85D04',
      kumkum: '#5B1A1E',
      gold: '#D4A64A',
      sandalwood: '#CDA982',
      tulsi: '#2F8F5B',
      lotus: '#E91E63',
      peacock: '#2F6FB0',
    }
  },
  typography: {
    fontFamily: '"Poppins", system-ui, -apple-system, "Segoe UI", sans-serif',
    h1: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600 },
    h2: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600 },
    h3: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600 },
    h4: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600 },
    h5: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600 },
    h6: { fontFamily: '"Playfair Display", Georgia, serif', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'dark' ? '#1D1713' : '#FFFFFF',
          color: mode === 'dark' ? '#F3EAE0' : '#2A1B12',
          borderBottom: `1px solid ${mode === 'dark' ? '#35291F' : '#EFE3D6'}`,
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: '9999px', fontWeight: 500 },
        contained: { boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: mode === 'dark' ? 'rgba(242, 115, 42, 0.18)' : 'rgba(232, 93, 4, 0.14)',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: mode === 'dark' ? '#1D1713' : '#FFFFFF',
          borderRight: `1px solid ${mode === 'dark' ? '#35291F' : '#EFE3D6'}`,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'dark' ? '#1D1713' : '#FFFFFF',
          backgroundImage: 'none',
          borderRadius: 16,
          border: `1px solid ${mode === 'dark' ? '#35291F' : '#EFE3D6'}`,
          boxShadow: '0 1px 2px rgba(64, 36, 12, .06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: mode === 'dark' ? '#1D1713' : '#FFFFFF',
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 12, backgroundColor: mode === 'dark' ? '#1D1713' : '#FFFFFF' },
      },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 999 } },
    },
  },
});

export const createAppTheme = (mode) => {
  return createTheme(getDesignTokens(mode));
};
